import {Component, OnDestroy, OnInit} from '@angular/core';
import {correctHeight, detectBody} from './app.helpers';
import {ErisLoginService} from './services/sso/eris-login.service';
import {Events} from './services/sso/constants';
import {AccountService} from './services/account.service';
import {Router} from '@angular/router';
import { setTheme } from 'ngx-bootstrap/utils';
import {Subscription} from 'rxjs';

declare var jQuery: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy, OnInit {
  private sessionCleared: Subscription;

  constructor(private erisLoginService: ErisLoginService, private router: Router, private accountService: AccountService) {
    setTheme('bs3'); // make ngx-bootstrap use bootstrap3
  }

  ngOnInit(): void {
    this.erisLoginService.instantiate();
    this.erisLoginService.userManager.events.addUserSignedOut(() => {
        this.accountService.removeData();
        this.router.navigateByUrl('/login');
    });

    // Access token expired (silent renew is disabled): /login starts a fresh sign-in through the STS.
    this.erisLoginService.eventSource.subscribe(event => {
      if (event === Events.TOKEN_EXPIRED) {
        this.accountService.removeData();
        this.router.navigateByUrl('/login');
      }
    });

    // The local session was dropped (sign-out here or in another tab, page restored after a sign-out,
    // token rejected by the API): wipe cached account data and show the sign-in page.
    this.sessionCleared = this.erisLoginService.sessionCleared.subscribe(reason => {
      this.accountService.removeData();
      this.router.navigate(['/login'], { queryParams: { reason } });
    });
  }

  ngAfterViewInit() {
    // Run correctHeight function on load and resize window event
    jQuery(window).bind('load resize', function () {
      correctHeight();
      detectBody();
    });

    // Correct height of wrapper after metisMenu animation.
    jQuery('.metismenu a').click(() => {
      setTimeout(() => {
        correctHeight();
      }, 300)
    });
  }

  ngOnDestroy(): void {
    if (this.sessionCleared) {
      this.sessionCleared.unsubscribe();
    }
    this.erisLoginService.cleanUp();
  }


}
